import API from "@/services/api/api.service";
import { Consent, ConsentVersion } from "@/utils/models/consent.model";
import { RouteLocationNormalized } from "vue-router";
import { consentResolver } from "./consent.resolver";
import { consentVersionResolver } from "./consent_version.resolver";

export const consentVersionRestoreResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        await Promise.all([consentResolver(to, from), consentVersionResolver(to, from)]);
    } catch (error) {
        console.error('CONSENT_VERSION_RESTORE_RESOLVER_ERROR');
        return { name: 'Consents' };
    }
}